if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        console.log('setActiveThumbnail')
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/**
 * HMX Mobile Product Gallery Swipe v1
 * Adds deliberate horizontal swipe detection and wraparound navigation to the
 * existing product media gallery without replacing thumbnails, arrows, zoom,
 * video/model controls, or the theme's accessibility announcements.
 */
(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px) and (hover: none)');
  const SWIPE_DISTANCE = 42;
  const SWIPE_VELOCITY = 0.28;
  const DIRECTION_RATIO = 1.18;

  const injectStyles = () => {
    if (document.getElementById('HmxMobileGallerySwipeStyles')) return;

    const style = document.createElement('style');
    style.id = 'HmxMobileGallerySwipeStyles';
    style.textContent = `
      @media screen and (max-width: 749px) {
        media-gallery .hmx-mobile-swipe-track {
          scroll-behavior: smooth;
          overscroll-behavior-inline: contain;
          -webkit-overflow-scrolling: touch;
        }

        media-gallery .hmx-mobile-swipe-viewer {
          position: relative;
        }

        media-gallery .hmx-mobile-swipe-hint {
          position: absolute;
          left: 50%;
          bottom: 1.2rem;
          z-index: 4;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          min-height: 3.4rem;
          padding: 0.65rem 1rem;
          border-radius: 999px;
          background: rgba(20, 20, 20, 0.78);
          color: #fff;
          box-shadow: 0 0.4rem 1.4rem rgba(0, 0, 0, 0.18);
          font-size: 1.15rem;
          font-weight: 700;
          line-height: 1;
          letter-spacing: 0.01em;
          pointer-events: none;
          opacity: 1;
          transform: translate(-50%, 0);
          transition: opacity 180ms ease, transform 180ms ease;
          white-space: nowrap;
        }

        media-gallery .hmx-mobile-swipe-hint.is-hidden {
          opacity: 0;
          transform: translate(-50%, 0.5rem);
        }

        @media (prefers-reduced-motion: reduce) {
          media-gallery .hmx-mobile-swipe-track {
            scroll-behavior: auto;
          }

          media-gallery .hmx-mobile-swipe-hint {
            transition: none;
          }
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getVisibleSlides = (gallery) =>
    Array.from(
      gallery.querySelectorAll('[id^="Slider-Gallery-"] > .product__media-item[data-media-id]')
    ).filter(
      (slide) =>
        !slide.classList.contains('hidden') &&
        slide.getClientRects().length > 0
    );

  const getCurrentIndex = (slides, track) => {
    const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex >= 0) return activeIndex;

    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
    return closestIndex;
  };

  const syncActiveSlide = (slides, activeSlide) => {
    slides.forEach((slide) => slide.classList.toggle('is-active', slide === activeSlide));
  };

  const initGallery = (gallery) => {
    if (gallery.dataset.hmxMobileSwipeReady === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const track = viewer?.querySelector('[id^="Slider-Gallery-"]');
    if (!viewer || !track || typeof gallery.setActiveMedia !== 'function') return;

    gallery.dataset.hmxMobileSwipeReady = 'true';
    viewer.classList.add('hmx-mobile-swipe-viewer');
    track.classList.add('hmx-mobile-swipe-track');

    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let lastY = 0;
    let startTime = 0;
    let gestureStarted = false;
    let horizontalGesture = false;
    let gestureCancelled = false;
    let suppressClick = false;
    let hintTimer;

    const hideHint = () => {
      const hint = viewer.querySelector('.hmx-mobile-swipe-hint');
      if (!hint) return;
      hint.classList.add('is-hidden');
      window.clearTimeout(hintTimer);
      window.setTimeout(() => hint.remove(), 220);
    };

    const addHint = () => {
      if (!MOBILE_QUERY.matches || getVisibleSlides(gallery).length < 2) return;
      if (viewer.querySelector('.hmx-mobile-swipe-hint')) return;

      const hint = document.createElement('div');
      hint.className = 'hmx-mobile-swipe-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<span aria-hidden="true">↔</span><span>Swipe photos</span>';
      viewer.appendChild(hint);
      hintTimer = window.setTimeout(hideHint, 4200);
    };

    const activateByDirection = (direction) => {
      const slides = getVisibleSlides(gallery);
      if (slides.length < 2) return;

      const currentIndex = getCurrentIndex(slides, track);
      const targetIndex = (currentIndex + direction + slides.length) % slides.length;
      const targetSlide = slides[targetIndex];
      const isWrap =
        (direction > 0 && currentIndex === slides.length - 1) ||
        (direction < 0 && currentIndex === 0);

      track.style.scrollBehavior = isWrap ? 'auto' : 'smooth';
      syncActiveSlide(slides, targetSlide);
      gallery.setActiveMedia(targetSlide.dataset.mediaId, false);
      hideHint();

      if (isWrap) {
        window.setTimeout(() => {
          track.style.scrollBehavior = '';
        }, 120);
      }
    };

    const resetGesture = () => {
      gestureStarted = false;
      horizontalGesture = false;
      gestureCancelled = false;
    };

    track.addEventListener(
      'touchstart',
      (event) => {
        if (!MOBILE_QUERY.matches || event.touches.length !== 1) return;
        if (getVisibleSlides(gallery).length < 2) return;

        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (
          target.closest(
            'video, iframe, model-viewer, .deferred-media, .product__xr-button, [data-shopify-xr], input, select, textarea, [contenteditable="true"]'
          )
        ) {
          return;
        }

        const button = target.closest('button');
        if (button && !button.classList.contains('product__modal-opener')) return;

        const link = target.closest('a');
        if (link && !link.classList.contains('product__modal-opener')) return;

        const touch = event.touches[0];
        startX = lastX = touch.clientX;
        startY = lastY = touch.clientY;
        startTime = performance.now();
        gestureStarted = true;
        horizontalGesture = false;
        gestureCancelled = false;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (event) => {
        if (!gestureStarted || gestureCancelled) return;
        if (!MOBILE_QUERY.matches || event.touches.length !== 1) {
          gestureCancelled = true;
          return;
        }

        const touch = event.touches[0];
        lastX = touch.clientX;
        lastY = touch.clientY;

        const deltaX = lastX - startX;
        const deltaY = lastY - startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (!horizontalGesture) {
          if (absY > 10 && absY > absX) {
            gestureCancelled = true;
            return;
          }

          if (absX > 10 && absX > absY * DIRECTION_RATIO) {
            horizontalGesture = true;
          }
        }

        if (horizontalGesture && event.cancelable) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    track.addEventListener(
      'touchend',
      (event) => {
        if (!gestureStarted || gestureCancelled || !horizontalGesture) {
          resetGesture();
          return;
        }

        const deltaX = lastX - startX;
        const deltaY = lastY - startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        const elapsed = Math.max(performance.now() - startTime, 1);
        const velocity = absX / elapsed;
        const intentionalSwipe =
          absX > absY * DIRECTION_RATIO &&
          (absX >= SWIPE_DISTANCE || velocity >= SWIPE_VELOCITY);

        if (intentionalSwipe) {
          if (event.cancelable) event.preventDefault();
          suppressClick = true;
          activateByDirection(deltaX < 0 ? 1 : -1);
          window.setTimeout(() => {
            suppressClick = false;
          }, 320);
        }

        resetGesture();
      },
      { passive: false }
    );

    track.addEventListener(
      'touchcancel',
      () => {
        resetGesture();
      },
      { passive: true }
    );

    track.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      },
      true
    );

    viewer.addEventListener('slideChanged', (event) => {
      const activeSlide = event.detail?.currentElement;
      if (!activeSlide?.dataset?.mediaId) return;
      syncActiveSlide(getVisibleSlides(gallery), activeSlide);
    });

    const previousButton = viewer.querySelector('.slider-button--prev');
    const nextButton = viewer.querySelector('.slider-button--next');

    previousButton?.addEventListener(
      'click',
      (event) => {
        if (!MOBILE_QUERY.matches) return;
        const slides = getVisibleSlides(gallery);
        if (slides.length < 2 || getCurrentIndex(slides, track) !== 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        activateByDirection(-1);
      },
      true
    );

    nextButton?.addEventListener(
      'click',
      (event) => {
        if (!MOBILE_QUERY.matches) return;
        const slides = getVisibleSlides(gallery);
        if (
          slides.length < 2 ||
          getCurrentIndex(slides, track) !== slides.length - 1
        ) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        activateByDirection(1);
      },
      true
    );

    addHint();
  };

  const initAllGalleries = (root = document) => {
    injectStyles();
    root.querySelectorAll('media-gallery').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllGalleries());
  } else {
    initAllGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllGalleries(event.target);
  });
})();
